import { getCardBySlug } from '../derived/cards-by-slug';
import type { CardLibraryEntry } from '../internal/types';

export type { CardLibraryEntry } from '../internal/types';

export async function loadCardLibraryEntry(slug: string): Promise<CardLibraryEntry | undefined> {
  const card = getCardBySlug(slug);

  if (!card) {
    return undefined;
  }

  if (card.arcana === 'major') {
    const module = await import('./major-library');
    return module.MAJOR_LIBRARY.find((entry) => entry.slug === slug);
  }

  switch (card.suit) {
    case 'Bastoni': {
      const module = await import('./minor-wands-library');
      return module.MINOR_WANDS_LIBRARY.find((entry) => entry.slug === slug);
    }
    case 'Coppe': {
      const module = await import('./minor-cups-library');
      return module.MINOR_CUPS_LIBRARY.find((entry) => entry.slug === slug);
    }
    case 'Spade': {
      const module = await import('./minor-swords-library');
      return module.MINOR_SWORDS_LIBRARY.find((entry) => entry.slug === slug);
    }
    case 'Denari': {
      const module = await import('./minor-pentacles-library');
      return module.MINOR_PENTACLES_LIBRARY.find((entry) => entry.slug === slug);
    }
    default:
      return undefined;
  }
}

